import { useSearch } from '@tanstack/react-router';

import type { VesselMessage } from '../../../../types/VesselMessage';
import { VesselOrderTable } from '../../VesselDetailPage/components/VesselOrderTable';
import { VesselProductsTable } from '../../VesselDetailPage/components/VesselProductsTable';
import { VesselContractsTable } from '../../VesselDetailPage/Contracts/VesselContractsTable';
import type { LubricationChartUpload } from '../../VesselDetailPage/hooks/useLubricationChartUpload';
import { ScheduleSection } from '../../VesselDetailPage/ScheduleSection/ScheduleSection';

import { VesselDetailPageOverviewContent } from './VesselDetailPageOverviewContent';

export const VesselDetailPageTabs = {
    OVERVIEW: 'overview',
    SCHEDULE: 'schedule',
    ORDERS: 'orders',
    PRODUCTS: 'products',
    CONTRACTS: 'contracts',
} as const;

// eslint-disable-next-line no-redeclare
export type VesselDetailPageTabs = (typeof VesselDetailPageTabs)[keyof typeof VesselDetailPageTabs];
interface VesselDetailPageSearch {
    tab: VesselDetailPageTabs;
}

interface VesselDetailPageContentProps {
    vessel: VesselMessage;
    lubricationChartUpload: LubricationChartUpload;
}

export const VesselDetailPageContent = ({ vessel, lubricationChartUpload }: VesselDetailPageContentProps) => {
    const routePath = '/_app/vessel/$id';

    const search: VesselDetailPageSearch = useSearch({ from: routePath });

    switch (search.tab) {
        case VesselDetailPageTabs.OVERVIEW:
            return <VesselDetailPageOverviewContent vessel={vessel} lubricationChartUpload={lubricationChartUpload} />;
        case VesselDetailPageTabs.SCHEDULE:
            return <ScheduleSection vessel={vessel} />;
        case VesselDetailPageTabs.ORDERS:
            return <VesselOrderTable vessel={vessel} />;
        case VesselDetailPageTabs.PRODUCTS:
            return <VesselProductsTable vessel={vessel} lubricationChartUpload={lubricationChartUpload} />;
        case VesselDetailPageTabs.CONTRACTS:
            return <VesselContractsTable vessel={vessel} />;
    }
};
